var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-skeleton", { staticClass: "mb-4", attrs: { type: "input" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "4", md: "12" } },
            [_c("b-skeleton-img")],
            1
          ),
          _vm._v(" "),
          _c("b-col", [_c("b-skeleton-img")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }